import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS, FONT } from './tokens';

export type OrgRole = 'admin' | 'leader' | 'member' | 'follower';

const LABELS: Record<OrgRole, string> = {
  admin: 'Admin',
  leader: 'Leader',
  member: 'Member',
  follower: 'Follower',
};

export const RoleBadge = ({ role }: { role: OrgRole }): ReactElement => (
  <Box
    sx={{
      backgroundColor: COLORS.pillBg,
      display: 'inline-flex',
      alignItems: 'center',
      px: '8px',
      py: '4px',
      borderRadius: '9999px',
    }}
  >
    <Typography
      sx={{
        fontFamily: FONT,
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '18px',
        color: COLORS.bodyDark,
      }}
    >
      {LABELS[role]}
    </Typography>
  </Box>
);
